export const SUPPORTS_ARRAY_PROTOTYPE_FLAT_MAP = "flatMap" in Array.prototype;
